// An official page of an event (website, Instagram, Facebook), on run events and scraped events.
// The API sets `type` from the URL's host; anything it doesn't recognise is Web.
export interface EventLink {
    title?: string;
    url: string;
    type?: EventLinkTypeEnum;
}

export enum EventLinkTypeEnum
{
    Web = 1,
    Instagram = 2,
    Facebook = 3,
}
export const EventLinkTypeList = [
    {value: 1, label: "Web"},
    {value: 2, label: "Instagram"},
    {value: 3, label: "Facebook"},
];

// Same rule as the API, so the type shows while editing, before saving.
export const eventLinkTypeFromUrl = (url?: string): EventLinkTypeEnum => {
    let host = '';
    try { host = new URL((url ?? '').trim()).hostname.toLowerCase(); } catch { return EventLinkTypeEnum.Web; }
    const isHost = (domain: string) => host === domain || host.endsWith('.' + domain);
    if (isHost('instagram.com') || isHost('instagr.am')) return EventLinkTypeEnum.Instagram;
    if (isHost('facebook.com') || isHost('fb.com') || isHost('fb.me')) return EventLinkTypeEnum.Facebook;
    return EventLinkTypeEnum.Web;
};

// Drops rows without a URL and sends only what the API reads (it sets the type itself).
export const cleanEventLinks = (links?: EventLink[]): EventLink[] =>
    (links ?? [])
        .map(l => ({ title: l.title?.trim() || undefined, url: (l.url ?? '').trim() }))
        .filter(l => l.url);
